import { ElMessage } from 'element-plus';

export function showMessage(message: string, type: 'success' | 'warning' | 'info' | 'error'): void {
  if (typeof message !== 'string' || message === '') {
    return;
  }
  ElMessage({
    message: message,
    type,
    duration: 2000
  });
}
